import React from 'react';
import { initialsOf, figure } from './FullScorecardGrid';
import './FullScorecardGrid.css';

/**
 * The Total tab — the pre-finalise check.
 *
 * Not a third nine: a ranked Out / In / Gross / Pts table over the whole field,
 * sorted by points, so an organiser can see the day's result in one glance
 * before locking it. It shares the card chrome and the navy header band with
 * FullScorecardGrid on purpose — it is the same card, showing the same round a
 * different way, not a leaderboard that happens to live here.
 *
 * Ties are NOT broken. This is a verification view, not the leaderboard, and
 * inventing a countback here would put a second answer on screen next to the
 * one the leaderboard gives.
 */
// No card at all sorts below a card of nought.
const rank = (pts) => (pts === '' || pts === null || pts === undefined ? -1 : Number(pts));

const FullScorecardTotals = ({ players, playerTotals, handicapFor }) => {
  const rows = players
    .map(p => {
      const t = playerTotals[p.id] || {};
      return {
        id: p.id,
        name: p.name,
        hcp: handicapFor(p.id),
        out: t.front9Gross,
        in: t.back9Gross,
        gross: t.totalGross,
        pts: t.totalStableford,
      };
    })
    // A player with no card yet sorts last — but a player who genuinely scored
    // nought is ahead of them, not level with them.
    .sort((a, b) => rank(b.pts) - rank(a.pts));

  const leaderPts = rows.length ? rank(rows[0].pts) : -1;

  return (
    <div className="fsc-card fsc-totals">
      <div className="fsc-totals-head">
        <span />
        <span>Player</span>
        <span className="fsc-totals-num">Out</span>
        <span className="fsc-totals-num">In</span>
        <span className="fsc-totals-num">Gross</span>
        <span className="fsc-totals-pts">Pts</span>
      </div>

      {rows.map((r, i) => {
        const isLeader = leaderPts >= 0 && rank(r.pts) === leaderPts;
        return (
          <div className={`fsc-totals-row${isLeader ? ' fsc-totals-row--leader' : ''}`} key={r.id}>
            <span className="fsc-totals-rank">{i + 1}</span>
            <span className="fsc-totals-player">
              <span className="fsc-totals-initials">{initialsOf(r.name)}</span>
              <span className="fsc-totals-hcp">
                {Number(r.hcp) < 0 ? `(+${Math.abs(Number(r.hcp))})` : `(${Number(r.hcp) || 0})`}
              </span>
            </span>
            <span className="fsc-totals-num">{figure(r.out)}</span>
            <span className="fsc-totals-num">{figure(r.in)}</span>
            <span className="fsc-totals-num fsc-totals-gross">{figure(r.gross)}</span>
            <span className="fsc-totals-pts">{figure(r.pts)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default FullScorecardTotals;
